import React from 'react';
import { LoginForm } from '@/components/auth/LoginForm';

export default function LoginPage() {
  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <React.Suspense
        fallback={
          <div className="w-full max-w-md rounded border border-white/10 bg-white/2 p-6 text-center text-sm text-white/60">
            Loading...
          </div>
        }
      >
        <LoginForm />
      </React.Suspense>
    </div>
  );
}
